import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
import axios from "axios"; // Import axios
import StudentAcadamicHistoryInfo from "../pages/StudentProfile/StudentAccademicHistory";

export const initialState = {
  currentStep: 1,
  formComplete: false,
  isAuthorized: false,
  parentType: "",
  applicantData: {},
  studentBasicInfo: {},
  parent1BasicInfo: {},
  parent2BasicInfo: {},
  studentInfo: {},
  parent1Info: {},
  parent2Info: {},
  studentHealthInfo: [],
  healthIssue: [],
  StudentAcadamicHistory: [],
  basicInfoId: null,
  studentId: null,
  fatherBasicInfoId: null,
  motherBasicInfoId: null,
  parentId: null,
  healthInfoId: null,
  applicantId: null,
  notification: {
    show: false,
    message: "",
    type: "",
  },
  formData: {},
  status: "idle",
  error: null,
  loading: false,
  parentInfoSubmitted: false,
};

// Extract applicant ID from token
const extractApplicantId = (token) => {
  const tokenParts = token.split(".");
  const payloadBase64 = tokenParts[1];
  const payload = JSON.parse(
    atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"))
  );
  return payload.ApplicantId;
};
export const fetchApplicantData = createAsyncThunk(
  "admission/fetchApplicantData",
  async (_, { dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("No authentication token found");
      }

      // Extract applicant ID from token (this might need adjustment based on your token structure)
      const applicantId = extractApplicantId(token);
      console.log("token", token);
      console.log(
        "path",
        `${API_BASE_URL}/api/ApplicantStudent/${applicantId}`
      );
      if (!applicantId) {
        throw new Error("Could not extract applicant ID from token");
      }
      const response = await fetch(
        `${API_BASE_URL}/api/ApplicantStudent/${applicantId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        const errorText = await response.text();
        console.error("API Error Response:", errorText);
        throw new Error(`Failed to fetch applicant data: ${errorText}`);
      }

      const applicantData = await response.json();

      // Map the API response to the form data structure
      const mappedData = {
        firstName: applicantData.firstName || "",
        surName: applicantData.surName || "",
        lastName: applicantData.lastName || "",
        email: applicantData.contactEmail || "",
        gender:
          applicantData.gender === 0
            ? "Male"
            : applicantData.gender === 1
            ? "Female"
            : "",
        phoneNumber: applicantData.phoneNumber || "",
        nationality: applicantData.nationality || "",
        birthCountry: applicantData.birthCountry || "",
        passportCountry: applicantData.passportCountry || "",
        passportNumber: applicantData.passportNumber || "",
        dob: applicantData.dob || "",
        primaryLanguage: applicantData.primaryLanguage || "",
        otherLanguages: applicantData.otherLanguages || "",
        religion: applicantData.religion || "",
        gradeNumber: applicantData.gradeNumber || "",
        birthCertificateFile: applicantData.birthCertificateFile || "",
        referenceHospital: applicantData.referenceHospital || "",
        doctorName: applicantData.doctorName || "",
        hospitalNumber: applicantData.hospitalNumber || "",
        doctorNumber: applicantData.doctorNumber || "",
        healthDescription: applicantData.healthDescription || "",
        vaccinationStatus: applicantData.vaccinationStatus || "",
        vaccinationExplanation: applicantData.vaccinationExplanation || "",
        healthID: applicantData.healthID || "",
        healthIssues: applicantData.healthIssues || [],
        parentGender: applicantData.parentGender || "",
        workPlace: applicantData.workPlace || "",
        workPosition: applicantData.workPosition || "",
        address: applicantData.address || "",
        poBox: applicantData.poBox || "",
        subCity: applicantData.subCity || "",
        kebele: applicantData.kebele || "",
        houseNumber: applicantData.houseNumber || "",
        mobilePhone: applicantData.mobilePhone || "",
        homePhone: applicantData.homePhone || "",
        officePhone: applicantData.officePhone || "",
        otherPhone: applicantData.otherPhone || "",
        faxNumber: applicantData.faxNumber || "",
        preferredPhoneType: applicantData.preferredPhoneType || "",
        parentEmail: applicantData.parentEmail || "",
        parentType: applicantData.parentType || "",
        relationshipToStudent: applicantData.relationshipToStudent || "",
        occupationType: applicantData.occupationType || "",
      };

      // Update form data
      Object.entries(mappedData).forEach(([field, value]) => {
        dispatch(updateFormField({ field, value }));
      });

      return applicantData;
    } catch (error) {
      console.error("Error in fetchApplicantData:", error);
      throw error;
    }
  }
);
// Update manageBasicInfo thunk
export const manageBasicInfo = createAsyncThunk(
  "admission/manageBasicInfo",
  async (data, { rejectWithValue }) => {
    try {
      // Create the submission data with proper photo fields
      const submissionData = {
        firstName: data.firstName,
        surName: data.surName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: data.phoneNumber,
        dob: data.dob,
        gender: data.gender,
        nationality: data.nationality,
        birthCountry: data.birthCountry,
        idInformationCountry: data.passportCountry,
        
        // Properly set photo metadata fields
        studentPhoto: data.photo?.base64 || null,
        photoFileName: data.photo?.name || "profile_photo.jpg",
        photoFileContentType: data.photo?.type || "image/jpeg",
      };
      
      console.log("Basic Info Submission Data:", submissionData);
      return submissionData;
    } catch (error) {
      console.error("Error in manageBasicInfo:", error);
      return rejectWithValue(error.message);
    }
  }
);

export const manageStudentInfo = createAsyncThunk(
  "admission/manageStudentInfo",
  async (data, { getState, rejectWithValue }) => {
    try {
      // Retrieve the token from local storage
      // Normalize student data
      const studentData = {
        primaryLanguage: data.primaryLanguage,
        otherLanguages: data.otherLanguages || "",
        religion: data.religion ? parseInt(data.religion) : null,
        gradeNumber: 1,
        birthCertificateFile: data.birthCertificateFile
          ? typeof data.birthCertificateFile === "string"
            ? data.birthCertificateFile
            : data.birthCertificateFile.base64
          : null,
      };

      // Validate required fields
      const requiredFields = ["primaryLanguage", "religion", "gradeNumber"];
      const missingFields = requiredFields.filter(
        (field) =>
          studentData[field] === null ||
          studentData[field] === undefined ||
          studentData[field] === ""
      );

      if (missingFields.length > 0) {
        console.error("Missing required student info fields:", missingFields);
        return rejectWithValue({
          message: `Missing required fields: ${missingFields.join(", ")}`,
        });
      } else {
        return studentData;
      }
    } catch (error) {
      console.error("Student Info Submission Error:", error);
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);

export const manageParentInfo = createAsyncThunk(
  "admission/manageParentInfo",
  async (data, { getState, rejectWithValue }) => {
    try {
      console.log("data", data);
      const parentInfoData = {
        workPlace: data.parentWorkPlace,
        workPosition: data.parentWorkPosition,
        address: data.parentAddress,
        poBox: data.parentPoBox || "",
        subCity: data.parentSubCity,
        kebele: data.parentKebele,
        houseNumber: data.parentHouseNumber,
        mobilePhone: data.parentMobilePhone,
        homePhone: data.parentHomePhone || "",
        officePhone: data.parentOfficePhone || "",
        otherPhone: data.parentOtherPhone || "",
        faxNumber: data.parentFaxNumber || "",
        idNumber: data.idNumber || "",
        preferredPhoneType: parseInt(data.parentPreferredPhoneType, 10) || 0,
        email: data.parentEmail,
        parentType: parseInt(data.parentType, 10) || 0,
        relationshipToStudent: data.parentRelationshipToStudent,
        occupationType: parseInt(data.parentOccupationType, 10) || 0,

        idCopyFile: data.idCopyFile
          ? typeof data.idCopyFile === "string"
            ? data.idCopyFile
            : data.idCopyFile.base64
          : null,
        idCopyFileName: data.idCopyFile
          ? data.idCopyFile.name || "passport_copy.pdf"
          : null,
        idCopyFileContentType: data.idCopyFile
          ? data.idCopyFile.type || "application/pdf"
          : null,
      };

      //     console.log("Step 4: Prepared parent data:", parentInfoData);
      return parentInfoData;
    } catch (error) {
      console.error("Student Info Submission Error:", error);
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);

export const manageHealthInfo = createAsyncThunk(
  "admission/manageHealthInfo",
  async ({ data, isHealthCheckMandatory }, { getState, rejectWithValue }) => {
    try {
      // First submit the health information
      console.log("healthInformation: data", data);
      console.log(
        "healthInformation: isHealthCheckMandatory",
        isHealthCheckMandatory
      );
      const healthInformation = isHealthCheckMandatory
        ? [
            {
              referenceHospital: data.referenceHospital,
              doctorName: data.doctorName,
              hospitalNumber: data.hospitalNumber,
              doctorNumber: data.doctorNumber,
              healthDescription: data.healthDescription,
              vaccinationStatus: data.vaccinationStatus,
              vaccinationExplanation: data.vaccinationExplanation || "",
            },
          ]
        : [];

      return healthInformation;
    } catch (error) {
      console.error("Student Health Info Submission Error:", error);
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);
export const manageHealthIssue = createAsyncThunk(
  "admission/manageHealthIssue",
  async ({ data, isHealthIssueRequired }, { getState, rejectWithValue }) => {
    try {
      console.log("data, isHealthIssueRequired", data, isHealthIssueRequired);

      const healthIssue = isHealthIssueRequired ? data.healthIssues : [];
      console.log("healthIssue", healthIssue);

      return healthIssue;
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to submit health issue information",
      });
    }
  }
);
//
export const manageStudentAcademicInfo = createAsyncThunk(
  "admission/manageStudentAcademicInfo",
  async ({ isAcademicRequired, data }, { getState, rejectWithValue }) => {
    try {
      const dataToSubmit = !isAcademicRequired
        ? []
        : {
            schoolName: data.schoolName,
            gradeFrom: parseInt(data.gradeFrom, 10), // Convert to integer
            gradeTo: parseInt(data.gradeTo, 10), // Convert to integer
            entryDate: `${data.entryDate}T00:00:00Z`,
            exitDate: `${data.exitDate}T00:00:00Z`,
            schoolPhoneNumber: data.schoolPhoneNumber,
            schoolAddress: data.schoolAddress,
            document: data.document,
          };
      return dataToSubmit;
    } catch (error) {
      console.error("Student Info Submission Error:", error);
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);// Update registerStudentFullInformationNew thunk
export const registerStudentFullInformationNew = createAsyncThunk(
  "admission/registerStudentFullInformationNew",
  async (_, { getState, rejectWithValue }) => {
    const isNotEmpty = (obj) => obj && Object.keys(obj).length > 0;
    try {
      const state = getState().applicationFormDetail;
      const {
        studentBasicInfo,
        parent1BasicInfo,
        parent2BasicInfo,
        studentInfo,
        parent1Info,
        parent2Info,
        studentHealthInfo,
        healthIssue,
        StudentAcadamicHistory,
      } = state;

      // Create student data with proper photo fields
      const studentData = {
        firstName: studentBasicInfo.firstName,
        surName: studentBasicInfo.surName,
        lastName: studentBasicInfo.lastName,
        gender: studentBasicInfo.gender,
        phoneNumber: studentBasicInfo.phoneNumber,
        email: studentBasicInfo.email,
        dob: studentBasicInfo.dob,
        nationality: studentBasicInfo.nationality,
        birthCountry: studentBasicInfo.birthCountry,
        primaryLanguage: studentInfo.primaryLanguage,
        otherLanguages: studentInfo.otherLanguages,
        religion: studentInfo.religion,
        gradeNumber: studentInfo.gradeNumber,
        birthCertificateFile: studentInfo.birthCertificateFile,
        
        // Include photo metadata from studentBasicInfo
        studentPhoto: studentBasicInfo.studentPhoto || "",
        photoFileName: studentBasicInfo.photoFileName || "",
        photoFileContentType: studentBasicInfo.photoFileContentType || "",
      };

      const parent = [];
      if (isNotEmpty(parent1BasicInfo) || isNotEmpty(parent1Info)) {
        parent.push({ ...parent1BasicInfo, ...parent1Info });
      }
      if (isNotEmpty(parent2BasicInfo) || isNotEmpty(parent2Info)) {
        parent.push({ ...parent2BasicInfo, ...parent2Info });
      }

      const studentHistory = [];
      if (isNotEmpty(StudentAcadamicHistory)) {
        studentHistory.push(StudentAcadamicHistory);
      }

      const formattedData = {
        student: studentData,
        healthInformation: studentHealthInfo,
        healthIssue: healthIssue,
        parent: parent,
        studentHistory: studentHistory,
      };

      console.log("Final payload with photo data:", formattedData);

      const response = await fetch(
        `${API_BASE_URL}/api/Student/create-student-account-new-parent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(formattedData),
        }
      );
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue({
          message: errorData.message || "Failed to submit student information",
        });
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);

// Similarly update registerStudentFullInformationExisting
export const registerStudentFullInformationExisting = createAsyncThunk(
  "admission/registerStudentFullInformationExisting",
  async (_, { getState, rejectWithValue }) => {
    const isNotEmpty = (obj) => obj && Object.keys(obj).length > 0;
    try {
      const state = getState().applicationFormDetail;
      const {
        studentBasicInfo,
        studentInfo,
        studentHealthInfo,
        healthIssue,
        StudentAcadamicHistory,
      } = state;

      const studentData = {
        firstName: studentBasicInfo.firstName,
        surName: studentBasicInfo.surName,
        lastName: studentBasicInfo.lastName,
        gender: studentBasicInfo.gender,
        phoneNumber: studentBasicInfo.phoneNumber,
        email: studentBasicInfo.email,
        dob: studentBasicInfo.dob,
        nationality: studentBasicInfo.nationality,
        birthCountry: studentBasicInfo.birthCountry,
        primaryLanguage: studentInfo.primaryLanguage,
        otherLanguages: studentInfo.otherLanguages,
        religion: studentInfo.religion,
        gradeNumber: studentInfo.gradeNumber,
        birthCertificateFile: studentInfo.birthCertificateFile,
        
        // Include photo metadata
        studentPhoto: studentBasicInfo.studentPhoto || "",
        photoFileName: studentBasicInfo.photoFileName || "",
        photoFileContentType: studentBasicInfo.photoFileContentType || "",
      };

      const studentHistory = [];
      if (isNotEmpty(StudentAcadamicHistory)) {
        studentHistory.push(StudentAcadamicHistory);
      }

      const formattedData = {
        student: studentData,
        healthInformation: studentHealthInfo,
        healthIssue: healthIssue,
        studentHistory: studentHistory,
      };

      console.log("Final payload with photo data:", formattedData);

      const response = await fetch(
        `${API_BASE_URL}/api/Student/create-student-account-existing-parent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(formattedData),
        }
      );
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        return rejectWithValue({
          message: errorData.message || "Failed to submit student information",
        });
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue({
        message: error.message || "Failed to submit student information",
      });
    }
  }
);

const admissionSlice = createSlice({
  name: "applicationFormDetail",
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;

      // Handle vaccination explanation and healthID
    },

    //studentInfo
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    setFormComplete: (state, action) => {
      state.formComplete = action.payload;
    },
    setAuthorized: (state, action) => {
      state.isAuthorized = action.payload;
    },
    showNotification: (state, action) => {
      state.notification.show = true;
      state.notification.message = action.payload.message;
      state.notification.type = action.payload.type;
    },
    setParentRelationship: (state, action) => {
      state.setParentRelationship = action.payload;
    },
    hideNotification: (state) => {
      state.notification.show = false;
      state.notification.message = "";
      state.notification.type = "";
    },
    resetForm: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(manageBasicInfo.pending, (state) => {
        state.status = "loading";
        console.log("Basic info submission pending...");
      })
      .addCase(manageBasicInfo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        console.log("state.currentStep", state.currentStep);
        if (state.currentStep === 1) state.studentBasicInfo = action.payload;
        else if (state.currentStep === 4)
          state.parent1BasicInfo = action.payload;
        else if (state.currentStep === 6)
          state.parent2BasicInfo = action.payload;
        else if (state.currentStep === 8)
          state.parent1BasicInfo = action.payload;
      })
      .addCase(manageBasicInfo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("Basic info submission failed:", action.error.message);
      })
      // Student Info

      .addCase(manageStudentInfo.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(manageStudentInfo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.studentInfo = action.payload;
      })
      .addCase(manageStudentInfo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("Student info submission failed:", action.error.message);
      })
      .addCase(manageParentInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
        console.log("Parent info submission pending...");
      })
      .addCase(manageParentInfo.fulfilled, (state, action) => {
        console.log("======================:", state.currentStep);
        state.loading = false;
        state.parentInfoSubmitted = true;
        if (state.currentStep === 5 || state.currentStep === 9) {
          state.parent1Info = action.payload;
          console.log("state.parent1Info: ", action.payload);
        } else if (state.currentStep === 7) {
          state.parent2Info = action.payload;
          console.log("state.parent2Info", action.payload);
        }
      })
      .addCase(manageParentInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        console.error("Parent info submission failed:", action.error.message);
      })
      // Health Info

      .addCase(manageHealthInfo.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(manageHealthInfo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.studentHealthInfo = action.payload;
        console.log("state.studentHealthInfo", state.studentHealthInfo);
        state.formComplete = true;
      })
      .addCase(manageHealthInfo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Health Issue

      .addCase(manageHealthIssue.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(manageHealthIssue.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.healthIssue = action.payload;
        console.log("state.healthIssue", state.healthIssue);
        state.formComplete = true;
      })
      .addCase(manageHealthIssue.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(manageStudentAcademicInfo.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(manageStudentAcademicInfo.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.StudentAcadamicHistory = action.payload;
        console.log(
          "state.StudentAcadamicHistory",
          state.StudentAcadamicHistory
        );
        console.log("action.payload", action.payload);
        state.formComplete = true;
      })
      .addCase(manageStudentAcademicInfo.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(registerStudentFullInformationNew.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(registerStudentFullInformationNew.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.error = null;
        state.formComplete = true;
      })
      .addCase(registerStudentFullInformationNew.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(registerStudentFullInformationExisting.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        registerStudentFullInformationExisting.fulfilled,
        (state, action) => {
          state.status = "succeeded";
          state.error = null;
          state.formComplete = true;
        }
      )
      .addCase(
        registerStudentFullInformationExisting.rejected,
        (state, action) => {
          state.status = "failed";
          state.error = action.payload?.message;
        }
      )

      .addCase(fetchApplicantData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchApplicantData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.applicantData = action.payload;
        state.error = null;
      })
      .addCase(fetchApplicantData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        console.error("Failed to fetch applicant data:", action.error.message);
      });
  },
});

export const {
  updateFormField,
  setCurrentStep,
  setFormComplete,
  setAuthorized,
  showNotification,
  setParentRelationship,
  hideNotification,
  resetForm,
  setStudentBasicInfo,
  setParent1BasicInfo,
  setParent2BasicInfo,
  setStudentInfo,
  setParent1Info,
  setParent2Info,
  setStudentHealthInfo,
} = admissionSlice.actions;

export default admissionSlice.reducer;
